import React, { Component } from 'react';
import { Card } from 'reactstrap';

class PostList extends Component {
  render() {
    return (
      <Card>
        Post List
      </Card>
    )
  }
}

export default PostList


// WEBPACK FOOTER //
// ./src/Components/Admin/PostList.js